import $ from 'jquery';

$(function () {

// League Menu Dropdown

$('.league-menu').each(function() {
  const $menu = $(this);
  const $btn = $menu.find('.btn-league');

  $btn.on('click', function() {
    const isActive = $btn.hasClass('btn-league--active'); // Check if the button is already active

    // Remove active class from all buttons and menus
    $('.btn-league').removeClass('btn-league--active');
    $('.league-menu').removeClass('league-menu--active');

    // Toggle active class on the clicked button and menu
    if (!isActive) {
      $(this).addClass('btn-league--active');
      $menu.addClass('league-menu--active');
    }
  });
});

  const $searchInput = $('.league-search .search-input');
  const $items = $('.table-league__item');
  const $noItems = $('.table-league__not-found');
  let sortAscendingPosition = true;
  let sortAscendingClient = true;

  $searchInput.on('input', function () {
    const searchValue = $searchInput.val().toLowerCase();
    filterItems(searchValue);
  });

  function filterItems(searchValue) {
    let itemsFound = false;

    $items.each(function () {
      const clientName = $(this).data('name').toLowerCase();

      if (clientName.includes(searchValue)) {
        $(this).show();
        itemsFound = true;
      } else {
        $(this).hide();
      }
    });

    if (!itemsFound) {
      $('.table-league__results').css('height', 'auto');
      $noItems.css('display','table-row');
    } else {
      $noItems.css('display','none');
    }

  }

});